import { Box, CssBaseline, Paper } from "@mui/material";
import AppBarHeader from "./AppBarHeader.jsx";
import SidebarMenu from "./SidebarMenu.jsx";

function AppLayout({ user, handleLogOut, children }) {
  return (
    <Box sx={{ 
      display: 'flex', 
      backgroundColor: "#cccccc", 
      minHeight: "100vh"
    }}>
      <CssBaseline />
      <AppBarHeader user={user} handleLogOut={handleLogOut} />
      <SidebarMenu />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 6,
          ml: -2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",              
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: "1575px",
            borderRadius: 3,
            p: 0.5,
            backgroundColor: "#fff"
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
}

export default AppLayout;
